// extracted by mini-css-extract-plugin
module.exports = {"action-btn":"add-to-cart_action-btn__pPpBo","quantity-container":"add-to-cart_quantity-container__A2q2p"};